export const vCardDetailsModal: string = 'vCardDetailsModal';
